import { validateAddress, validateAddress2, validateCity, validateEmail, validateIncome, validatePhoneStruct, validateZip, } from "./getFormRulesMessages";
var getFormRulesMessages = function () {
    return {
        required: {
            value: true,
            message: "forms.errors.rules.required",
        },
        validateIncome: validateIncome,
        validateAlertsPhone: function (value) { return ({
            value: value,
            message: "forms.errors.phone.alerts",
        }); },
        validateZip: validateZip,
        validateAddress: validateAddress,
        validateAddress2: validateAddress2,
        validateCity: validateCity,
        validateEmail: validateEmail,
        validatePhoneStruct: validatePhoneStruct,
    };
};
export default getFormRulesMessages;
